import { useContext } from 'react'

import { useSelector } from 'react-redux'
import { Switch } from 'antd'
import { isFunction, snakeCase } from 'lodash'

import { firstOrDefault, toFirstUpperCase } from '../../../utils'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { InstitutionConstraintModalContext } from '../../../Providers/Forms/InstitutionConstraint/InstitutionConstraintModalProvider'
import { InstitutionConstraint, InstitutionConstraintProperties as Properties } from '../../../utils/entities/institutionConstraints'
import DataTable from '../../antd/Tables/DataTable/DataTable'
import { DeleteAction } from '../../antd/Tables/DataTable/utils/actions'
import { Actions } from './InstitutionConstraintsCard'
import { selectUser } from '../../../reducers/UserReducer'

const InstitutionConstraintTable = ({ data, loading, metadata, tableParameters, onAction, onParametersChange }) => {
  const { setFormHandler } = useContext(InstitutionConstraintModalContext)

  const user = useSelector(selectUser)
  const t = useSelector(selectTranslate)

  const openModal = () => setFormHandler({ data: new InstitutionConstraint({ institution: firstOrDefault(user.institutions) }), callback: onAction })

  const handleAction = action => institutionConstraint => onAction(institutionConstraint, action)
  const isActionDisabled = !isFunction(onAction)

  const actions = [
    new DeleteAction({
      disabled: isActionDisabled,
      popconfirmTitle: 'institution_constraint_table.actions.delete.confirm',
      onDelete: handleAction(Actions.DELETE)
    })
  ]

  const toUpperTranslated = property => toFirstUpperCase(t('common.' + snakeCase(property)))

  const columnsMap = {
    [Properties.PROPERTY_NAME]: {
      title: t('common.properties'),
      key: c => toUpperTranslated(c[Properties.PROPERTY_NAME])
    },
    [Properties.ENABLE]: {
      title: toUpperTranslated('enabled'),
      key: c => <Switch checked={c[Properties.ENABLE]} disabled={isActionDisabled} onClick={() => onAction(c, Actions.TOGGLE)} />
    }
  }

  const columns = Object.entries(columnsMap).map(([property, config]) => ({
    title: config.title,
    key: config.key,
    orderBy: property
  }))

  return (
    <DataTable
      actions={actions}
      data={data}
      metadata={metadata}
      loading={loading}
      parameters={tableParameters}
      columns={columns}
      onCreate={openModal}
      onParametersChange={onParametersChange}
    />
  )
}

export default InstitutionConstraintTable
